var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showModal)?_c('d-modal',{on:{"close":_vm.handleClose}},[_c('d-modal-header',[_c('d-modal-title',[_vm._v(_vm._s(_vm.title))])],1),_c('d-modal-body',[_vm._v(_vm._s(_vm.message))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }